import { render, staticRenderFns } from "./IngredientGroupEdit.vue?vue&type=template&id=2da6453b&scoped=true"
import script from "./IngredientGroupEdit.vue?vue&type=script&lang=js"
export * from "./IngredientGroupEdit.vue?vue&type=script&lang=js"
import style0 from "./IngredientGroupEdit.vue?vue&type=style&index=0&id=2da6453b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da6453b",
  null
  
)

export default component.exports